if (typeof BSS_B2B === 'undefined') {
  console.warn('BSS_B2B not defined - bss_custom.js execution stopped safely.');
} else {

setTimeout(() => {
let QuickView = document.querySelectorAll('.sf__pcard-quick-add button')
if (QuickView.length) {
QuickView.forEach((e) => {
e.addEventListener("click", () => {
setTimeout(async () => {
const res = await BSS_B2B.storage.productStorage.load();
if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                        ...res,
                        });
                    }
                }, 2000)
            })
        })

    }
}, 2500)
setTimeout(() => {
let quickOder = document.querySelectorAll('.sf-product-variant-option-dropdown option')
if (quickOder.length) {
quickOder.forEach((e)=>{
let varriant = e.value
let price 
let a = document.querySelector(`.bss-b2b-quick-order-list [bss-b2b-variant-id='${varriant}'] `);
let variantPrice = BSS_B2B.storage.variantStorage.get(Number(varriant));
if (a.innerHTML.includes('span')) { 
price = a.querySelector('span').innerText  
e.innerText = e.innerText.split("$")[0] +' - ' + price
      }else { 
e.innerText = e.innerText.split("$")[0]+ ' - '+ variantPrice.price
      }
    })
  }
}, 4000)



const customerTags = ['b2b', 'tier1']

document.addEventListener("DOMContentLoaded", ()=>{
const interval = setInterval(() =>{
if(BSS_B2B.on && BSS_B2B.on.status){
BSS_B2B.on.status = false;
if (BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.customer && BSS_B2B.shopData.customer.tags) {
const hasMatchingTag = customerTags.some(tag => BSS_B2B.shopData.customer.tags.includes(tag));
if (hasMatchingTag) {
BSS_B2B.on.status = true;
          }
        }
    }
  },50)
setTimeout(()=>{
clearInterval(interval)
  },2000)
})

}